import React from 'react';

export function WhatIsSMS() {
  return (
    <details className="my-1 cursor-pointer text-sm text-gray-500">
      <summary>What is SMS Authentication?</summary>
      <div className="mt-2 rounded-md border border-gray-200 p-4">
        <p>
          When you sign in with your email and password, we will send you a 6-digit code by SMS.
        </p>
        <p className="mt-2">Note that standard SMS rates apply to all messages sent.</p>
      </div>
    </details>
  );
}
